import React, { useEffect, useState } from 'react';
import { getMDTReportsByPatient } from "../services/mdtReportService"
import { Eye } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { MDTReport } from '../types';


interface MDTReportsTabProps {
  getStatusColor: (status: string) => string;
}

const MDTReportsTab: React.FC<MDTReportsTabProps> = ({ 
  getStatusColor,
}) => {
  const { id } = useParams<{ id: string }>();
  const [reports, setReports] = useState<MDTReport[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        setError(null);

        const reportsData = await getMDTReportsByPatient(id);

        setReports(reportsData);
      } catch (err) {
        console.error(err);
        setError("Failed to load MDT reports");
      } finally {
        setLoading(false);
      }
    };
    fetchReports();
  }, [id]);

  if (loading) return <p>Loading reports...</p>;
  if (error) return <p>{error}</p>;
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">MDT Reports</h3>

      <div className="space-y-4">
        {reports.length === 0 ? (
          <p className="text-sm text-gray-500">No MDT reports available.</p>
        ) : (
          reports.map((report) => (
            <div key={report.id} className="card">
              {/* Header */}
              <div className="flex items-center justify-between">
                <div className='flex flex-col space-y-3'>
                  <h4 className="font-medium text-gray-900">MDT Report : {report.id}</h4>
                  <p className="text-sm text-gray-600">
                    Generated by {report?.created_by?.name}
                  </p>
                  <p className="text-sm text-gray-600">
                    {new Date(report?.createdAt).toLocaleDateString()}
                  </p>
                </div>
                <div className='flex flex-col items-end'>
                  <span
                    className={`w-fit px-3 py-1 text-sm font-medium rounded-full ${getStatusColor(
                      report.status
                    )}`}
                  >
                    {report.status.replace('_', ' ')}
                  </span>
                  {/* Actions */}
                  <div className="flex justify-end space-x-2 mt-4">
                    <button 
                      onClick={() => navigate(`/reports/${report.id}`, {
                        state: { 
                          from: "patient",
                          patientId: report?.patient?.patient_id
                        }
                      })}
                      className="btn-primary flex items-center space-x-2"
                    >
                      <Eye className="h-4 w-4" />
                      <span>View Report</span>
                    </button>
                    {/* <button
                      onClick={() => onEditReport?.(report)}
                      className="btn-primary"
                    >
                      Edit Report
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MDTReportsTab;

